// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tipvr","right":"styles_right__2D-zf"};